/** ארבעה סוגריים זוויתיים בציאן על פינות האלמנט ההורה (position:relative) */
export function HudCorners() {
  return (
    <span className="hud-corners" aria-hidden="true">
      <span />
      <span />
      <span />
      <span />
    </span>
  );
}
